
const restRequest = (actions: any, options: any,log:any) => {
    if (actions) {
      actions.updatecv(options)
        .catch((e: any) => {
          log.error(
            "one-micro-quickmenu",
            "updatepv-restRequest",{
              e
            }
          );
        });
    }
  }
  
  const updatePV=(actions: any,pv_label:any,pv_value:any,log:any) =>{
    //get the selected type
    //let selected=sessionStorage.getItem("selected")
        let callvar = {
          "name" : pv_label,
          "value" : pv_value
  
      };
      let callvariable = { "CallVariable" : callvar };
      let mediaProperties = { "callvariables": callvariable };
      let options:any = options || {};
      options.content = {};
      options.content["Dialog"] =
      {
        "mediaProperties": mediaProperties,
        "requestedAction": "UPDATE_CALL_DATA"
      };
      options.method = "PUT";
      options.success = function() {
        log.debug(
          "one-card-drawer",
          "updatepv-Call Vars updated successfully"
        );
      };
      options.error = function() {
        log.error(
          "one-card-drawer",
          "updatepv-Failed to update call variable"
        );
      };
      // Update the variables
      restRequest(actions,options,log);
  }
  
  export const UpdatePVvalue = (pv_label: any, pv_value: any, actions: any, settings: any, log: any) => {
    
    log.debug("one-card-drawer",
              "UpdatePVvalue::", pv_label, pv_value);
    
    const { updatepv } = settings;
    let updatepvornot = false;
    let pvarariable = updatepv?.[pv_label];
    if(pvarariable && pvarariable != "" ){
      updatepvornot = true;
    }
    log.debug("UpdatePVvalue",
              "updatepvornot::", updatepvornot);
    if(updatepvornot){
        updatePV(actions,pvarariable,pv_value,log);
    }
    
  };